module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = 1